import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectField } from "@cinch-labs/design-system";
import { useCarReviewsHubTracking } from "@cinch-nx/data-tracking";
import styles from "./filters.module.css";
function onMakeChange({ setIsLoading , trackOnFilterChange , isISR =false  }) {
    return (event)=>{
        setIsLoading(true);
        trackOnFilterChange(event.currentTarget.value, "make");
        const rawParams = {};
        if (event.currentTarget.value) {
            rawParams.make = event.currentTarget.value;
        }
        if (isISR) {
            window.location.href = `/reviews/${rawParams.make}`;
            return;
        }
        const urlParams = new URLSearchParams(rawParams);
        window.location.href = `/reviews?${urlParams.toString()}`;
    };
}
function onModelChange({ selectedMake , setIsLoading , trackOnFilterChange , isISR =false  }) {
    return (event)=>{
        setIsLoading(true);
        trackOnFilterChange(event.currentTarget.value, "model");
        const rawParams = {
            make: selectedMake
        };
        if (event.currentTarget.value) {
            rawParams.model = event.currentTarget.value;
        }
        if (isISR) {
            window.location.href = `/reviews/${rawParams.make}/${rawParams.model}`;
            return;
        }
        const urlParams = new URLSearchParams(rawParams);
        window.location.href = `/reviews${urlParams.toString() ? `?${urlParams.toString()}` : ""}`;
    };
}
export const Filters = ({ selectedMake ="" , selectedModel ="" , makes =[] , models =[] , isLoading , setIsLoading , isISR =false  })=>{
    const { trackOnFilterChange  } = useCarReviewsHubTracking();
    const selectFieldClassNames = {
        container: styles.selectContainer,
        select: styles.select
    };
    selectedMake = selectedMake ?? "";
    selectedModel = selectedModel ?? "";
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(SelectField, {
                id: "make-options",
                placeholder: "All makes",
                value: selectedMake,
                disabled: isLoading,
                options: [
                    {
                        label: "All makes",
                        value: ""
                    },
                    ...makes.map((make)=>({
                            label: make,
                            value: make
                        }))
                ],
                label: "Filter by make",
                classNames: selectFieldClassNames,
                onChange: onMakeChange({
                    setIsLoading,
                    trackOnFilterChange,
                    isISR
                })
            }),
            /*#__PURE__*/ _jsx(SelectField, {
                id: "model-options",
                placeholder: "All models",
                value: selectedModel,
                options: [
                    {
                        label: "All models",
                        value: ""
                    },
                    ...models.map((model)=>({
                            label: model,
                            value: model
                        }))
                ],
                label: "Filter by model",
                classNames: selectFieldClassNames,
                disabled: isLoading || selectedMake === "",
                onChange: onModelChange({
                    selectedMake,
                    setIsLoading,
                    trackOnFilterChange,
                    isISR
                })
            })
        ]
    });
};
